// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var EmailDraft = function (x) {
    return x;
};
var tsBridgeEmailDraft = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("EmailDraft")("__brandEmailDraft"));
    }
};
var writeEmailDraft = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showEmailDraft = Data_Show.showString;
var readEmailDraft = Simple_JSON.readString;
var ordEmailDraft = Data_Ord.ordString;
var newtypeEmailDraft = {
    Coercible0: function () {
        return undefined;
    }
};
var makeEmailDraft = EmailDraft;
var eqEmailDraft = Data_Eq.eqString;
export {
    EmailDraft,
    makeEmailDraft,
    unwrap,
    newtypeEmailDraft,
    eqEmailDraft,
    ordEmailDraft,
    showEmailDraft,
    readEmailDraft,
    writeEmailDraft,
    tsBridgeEmailDraft
};
//# sourceMappingURL=index.js.map
